import { initAnimalDetail } from "./AnimalDetail";
import { initAdoptListing } from "./AnimalListing";

export default class AnimalOs {
	constructor() {
		initAdoptListing();
		initAnimalDetail();
	}
}